import * as Styled from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightPurchaseFooter/GreenlightPurchaseFooter.styled';
import type { AvailableReport } from 'api/historyCheck.typed';
import { useGreenlightPurchase } from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightPurchaseFooter/GreenlightPurchaseAuth.hook';

export function GreenlightPurchaseFooter(props: {
  currentReport: AvailableReport;
  reportText: string;
  registration: string;
}) {
  const { reportText, currentReport, registration } = props;
  const { handlePaymentUrl } = useGreenlightPurchase({ registration });

  return (
    <Styled.StickyFooter position={'fixed'} fade={false}>
      <Styled.FooterContentWrapper>
        <Styled.FooterText>
          {reportText}
          <strong>{currentReport.formattedPrice}</strong>
        </Styled.FooterText>
        <Styled.Button
          data-testid={'purchase-button'}
          onClick={handlePaymentUrl}
        >
          {currentReport.button.title}
        </Styled.Button>
      </Styled.FooterContentWrapper>
    </Styled.StickyFooter>
  );
}
